import {
    convertToStoryFiles,
    convertToStoryImages,
    convertToStoryVideos,
    getMappedStatementsByFramework,
    getMappedBehaviors,
} from 'web-app/react/entities/observations/helpers';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import ObservationBehaviors from 'web-app/behaviors/observation-behavior-ids';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import * as Constants from './constants';

export const feedItemIsObservation = item => feedItemIsType(item, Constants.EmbedType.OBSERVATION);

export const feedItemIsInvoice = item => feedItemIsType(item, Constants.EmbedType.INVOICE);

export const feedItemIsType = (item, embedType) => {
    return item && item.embed && item.embed.get('type') === embedType;
};

export const getObservationFeedItem = (item, observations, frameworks) => {
    if (!observations || !frameworks || !feedItemIsObservation(item)) {
        return item;
    }

    const observation = observations.find(obs => obs.id === item.embed.get('observationId'));
    if (!observation) {
        return item;
    }

    const behaviors = new BehaviorsCollection(getMappedBehaviors(observation));
    return item.merge({
        body: observation.remark.body,
        richTextBody: observation.remark.richTextBody,
        nextStep: observation.nextStep ? observation.nextStep.body : undefined,
        richNextStep: observation.nextStep ? observation.nextStep.richTextBody : undefined,
        videos: convertToStoryVideos(observation.videos),
        images: convertToStoryImages(observation.images),
        files: convertToStoryFiles(observation.files),
        canDelete: behaviors.includes(ObservationBehaviors.CanDeleteObservation),
        canEdit: behaviors.includes(ObservationBehaviors.CanEditObservation),
        variant: observation.variant,
        embed: item.embed.merge({
            observation: {
                ...observation,
                behaviors,
            },
            observationStatementGroups: getMappedStatementsByFramework(
                observation.remark.statements,
                observation.remark.areas,
                frameworks,
            ),
            frameworks,
        }),
    });
};

export const getValueForRichTextBody = feedItem => {
    // If a draft was created using plain-text but now loaded as rich-text we should pipe the plain body into the rich body
    // so the "richTextBody" form element will initialise properly
    return hasValue(feedItem.richTextBody) && feedItem.richTextBody !== '' ? feedItem.richTextBody : feedItem.body;
};
